import script from "./GameMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./GameMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./GameMultiSelect.vue?vue&type=style&index=0&id=1f802b15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f802b15"]])

export default __exports__